import { type ProcessingMode } from '../model';

export const isProcessingMode = (value: string): value is ProcessingMode => {
    return value === 'payin' || value === 'payout';
};
